import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initSentry } from './lib/sentry'; // Sentry error tracking
import './App.css';
import './styles/safari-ios-fixes.css'; // Correções Safari iOS
import './utils/cloudflare-analytics-fix';
import './pwa-init'; // Inicializa PWA Service Worker

// Inicializar Sentry ANTES de renderizar a aplicação
initSentry();

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('Root element not found!');
} else {
  const root = createRoot(rootElement);
  root.render(
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  );
}
